import { Component, NgZone, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { API } from 'aws-amplify';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subscription } from 'rxjs';
import { AppService } from 'src/app/core/services/app.service';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { ContractService } from 'src/app/core/services/contract.service';
import { Web3Service } from 'src/app/core/services/web3.service';
import { environment } from 'src/environments/environment';
declare let $: any;
@Component({
  selector: 'app-nft-collections',
  templateUrl: './nft-collections.component.html',
  styleUrls: ['./nft-collections.component.scss']
})
export class NftCollectionsComponent implements OnInit {

  collectionsList = [];
  tokenURIsList = [];
  searchfil;
  accountNumber: any;
  balance: string;
  collectionsData: any;
  marketPlace: any;
  userInfo: any;
  sortByList: any = [{ id: 1, name: "Recently Added", sortName: "recent" }, { id: 2, name: "Most Viewed", sortName: "mostviewed" }]
  sortName: string = "Recently Added";
  sortBy: string = "SortBy";
  categoriesList: any;
  selectedCategory: number;
  searchkey: string = '';
  lastEvaluatedKey: any;
  dataEnded: any = false;
  start: number = 8;
  chain : string;
  accounchanged: Subscription;
  chainID: any = "Network";
  constructor(private router: Router, private appService: AppService, private web3service: Web3Service, private commanService: CommanSubscribeService, private ngxLoader: NgxUiLoaderService, public toaster: ToastrService,     private ngZone: NgZone,) { }

  ngOnInit() {
    this.userInfo = this.commanService.userInfo;
    this.getCollectionsApiCall();
    this.getCategories();

    this.ngZone.run(() => {
      this.accounchanged = this.web3service
        .getchangeaccount()
        .subscribe((data) => {
          this.web3service.getchainId().then((network) => {
            this.chainID = network;
            this.accountChanged(data);
          });
        });
    });


    (window as any).ethereum.on('chainChanged', (network) => {
      this.ngZone.run(() => {
        this.web3service.getchainId().then(() => {
          this.web3service.sendchangedaccount();
          this.getCollectionsApiCall();
        });
      });
    })

    if (localStorage.getItem("WalletId") != "") {
      this.accountNumber = localStorage.getItem("WalletId");
      this.web3service.intermidateConnect().then((data) => {
        if(data){
        this.web3service.getchainId().then((netwrok) => {
          if (netwrok != "Network") {
            this.accountChanged(this.accountNumber);
          }
        });
      }
      else{
        alert('undefined')
      }
      });
    } else {
      this.web3service.connectedAccId.subscribe(
        (walletId) => (this.accountNumber = walletId)
      );
      this.web3service.connectedAccId.subscribe(
        (walletId) => (this.accountNumber = walletId)
      );
    }
    this.web3service.connectedAccId.subscribe((walletId) => {
      if (walletId != "") {
        this.accountNumber = walletId;
      }
    });
  }

  accountChanged(walletId) {
    if (walletId != "") {
      this.web3service.setContract();
      this.accountNumber = walletId;
    }
  }

  getdata(data) {
    this.router.navigate(['nft/collections/products/' + data.id])
  }
  busyGettingData = false;
  onScrollDown() {
    // you're at the bottom of the page
    if(this.dataEnded) {
      return;
    }
    this.ngxLoader.start()
    if (this.collectionsList.length && this.lastEvaluatedKey == undefined && !this.dataEnded) {
      this.dataEnded = true;
      this.ngxLoader.stop();
      // this.toaster.success("End of Data");
    }
    else if (!this.busyGettingData){
      this.ngxLoader.start()
      this.busyGettingData = true;
      this.getCollectionsApiCall(this.lastEvaluatedKey);
      this.ngxLoader.stop();
    }
  }
  scrollheader(data) {
    let scrol = document.getElementById('categoryBtns');
    if (data == 'left') {
      scrol.scrollLeft = scrol.scrollLeft - (scrol.offsetWidth / 2);
    }
    else {
      scrol.scrollLeft = scrol.scrollLeft + (scrol.offsetWidth / 2);
    }
  }
  getSelectedCategory(category) {
    if (this.selectedCategory == category)
      this.selectedCategory = -1;
    else {
      this.selectedCategory = category;
    }
    this.getCollectionsApiCall();
  }

  getCollectionsApiCall(key?) {
    this.ngxLoader.start();
    let url = "nftCollections";
    this.chain = localStorage.getItem('networkId') ? localStorage.getItem('networkId')  : "Polygon"
    let payload = {
      limit: this.start,
      sortOnViews: this.sortBy == 'SortBy' ? 'recent' : this.sortBy,
      searchKey: this.searchkey,
      category_id: this.selectedCategory > 0 ? this.selectedCategory : undefined,
      sortOrder: false,
      LastEvaluatedKey: key ? key : undefined,
      chain: this.chain
    }
    let myInit = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: payload
    }
    API.post(environment.AWS_Cognito.apiName, url, myInit).then(response => {
      if (response.data.statusCode == '200') {
        let data = response.data.Data.Items;
        this.lastEvaluatedKey = response.data.Data.LastEvaluatedKey
        if (key) {
          this.start = this.start + 8;
          data.map((item) => {
            this.collectionsList.push(item)
          })
          this.busyGettingData = false;
        }
        else {
          this.collectionsList = data;
        }
      }
      this.ngxLoader.stop();
    }).catch(error => {
      this.busyGettingData = false
      this.ngxLoader.stop()
      console.log(error)
    });

  }

  sortbyfilter(sort) {
    this.sortName = sort.name;
    this.sortBy = sort.sortName;
    this.getCollectionsApiCall();
  }

  getCategories() {
    this.ngxLoader.start();
    let url = "nftCategories"
    let myInit = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {}
    }
    API.post(environment.AWS_Cognito.apiName, url, myInit).then(response => {
      this.categoriesList = response.data.response.Items;
    }).catch(error => {
      console.log(error)
      this.ngxLoader.stop()
    });
    this.ngxLoader.stop()
  }

  // Network Change

  networkChange(data) {
    this.chain = data == 'poly' ? 'Polygon' : 'Sepolia';
    
    this.web3service.changeNetwork(data).then(async (data)=>{
      await this.web3service.getchainId().then((network) => {
        this.chainID = network;
      });
    });
    this.web3service.changeContract();
    this.getCollectionsApiCall();
    // window.location.reload();

  }
}
